import HttpService from "@/utils/httpData"

export const getListMemberByGroupId = id => {
    let apiEndpoint = `ClassSchoolGroupUser/GetListMemberByGroupId?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}